import { Badge, Box, Dialog, DialogActions, DialogContent, DialogTitle, IconButton, List, ListItem, ListItemIcon, ListItemText, Stack, TextField, Typography, alpha } from "@mui/material";
import { UButton, UListItemButton } from "../common/ui.buttons";
import { GREY, MAIN_COLOR, MAIN_COLOR_ACTIVE, SECONDARY_COLOR, WARN_COLOR, WHITE } from "../style/theme";
import { createRef, useEffect, useState } from "react";
import { UDialgoCloseIcon, UDialog, UDialogClose, UDialogCloseOnCompleteButton, useDialog } from "../common/ui.dialog";
import { UMargin, UMarginBottom, UMarginTop, URow, USticky } from "../common/ui.page";
import { CUnitSelection } from "./cr.ui.order";
import { useCrusade } from "./crusade";
import { WCodexIcon } from "./wh.ui.icons";
import { useRestCall } from "../common/rest";
import { group } from "../common/util";
import { Close } from "@mui/icons-material";
import { UIcon } from "../common/ui.icon";
import { CUnitBox, CUnitBoxName, CUnitGrade } from "./cr.ui.unit";
import { UNIT_SORT } from "./unit";
import { BStoneIcon } from "./cr.ui.ext.pnex";
import { useExt } from "./ext";

export function CMatchButton(props) {
    const { color, primary, secondary, alert, icon } = props;

    return <UListItemButton sx={{
        border: '9px solid ' + GREY[100],
        borderLeft: 'none',
        zIndex: 2,
        padding: 0,
        paddingX: 2,
        background: 'linear-gradient(90deg, ' + color + ' 0%, ' + GREY[100] + ' 100% )',
    }}>
        <Badge sx={{ flex: 1 }} anchorOrigin={{
            horizontal: 'left',
            vertical: 'top'
        }} badgeContent={alert}
            color="warning">
            <ListItemText
                primary={primary}
                secondary={secondary}
                secondaryTypographyProps={{ sx: { color: GREY[100], fontWeight: 600, lineHeight: 1 } }}
            />
        </Badge>
        {icon}
    </UListItemButton>
}

export function CMatchDetails(props) {
    const { button, match, onClose } = props;

    return <UDialog fullScreen button={button} >
        <DialogTitle>
            <Stack alignItems="center" direction="row">
                <Typography sx={{ fontWeight: 600, fontSize: 16, flex: 1 }}>
                    {match.name}
                </Typography>
                <UDialgoCloseIcon onClick={onClose} />
            </Stack>
        </DialogTitle>
        <DialogContent sx={{ paddingBottom: 12 }}>
            <Typography>Missione</Typography>
            <Typography sx={{ whiteSpace: 'pre-wrap', fontSize: 12, color: GREY[800] }}>
                {match.description}
            </Typography>
            <UMarginTop margin={6}>
                {props.children}
            </UMarginTop>
        </DialogContent>
    </UDialog>
}

function CMatchInfoLine(props) {
    const { title, description, ...rest } = props;

    return <UMargin {...rest}>

        <Typography sx={{ color: GREY[700], fontWeight: 600 }}>{title}</Typography>
        <Typography sx={{ fontSize: 12 }}>
            {description}
        </Typography>
    </UMargin>
}

export function CMatch(props) {
    const { match, ...rest } = props;
    const icon = match.winner ? <UIcon name="winner" /> : undefined

    return <CMatchButton icon={icon} disabled={true} color={GREY[500]} primary={match.name} secondary={new Date(match.date).toLocaleDateString('it-IT')} />
}

export function CPlayer(props) {
    const ext = useExt()
    const { player, ...rest } = props;
    var wins = []
    var winExtra = <></>
    for (let i = 0; i < player.wins; i++) {
        wins.push(<UIcon key={'w' + i} name="winner" />)
    }
    if (player.wins > 7) {
        wins = [<UIcon name="winner" />]
        winExtra = <Typography>x{player.wins}</Typography>
    }

    return <UDialog fullWidth button={<CPlayerButton player={player} />}>
        <DialogTitle>
            <Stack direction={"row"} alignItems="center" >
                {ext.playerDetailIcon(player)}
                <ListItemText
                    primary={player.name}
                    secondary={player.codex.name}
                    secondaryTypographyProps={{ sx: { color: GREY[900] } }}
                />
                <WCodexIcon name={player.codex.name} />
            </Stack>
        </DialogTitle>
        <DialogContent>
            <Stack spacing={2} direction="row" justifyContent="center" >
                {wins}{winExtra}
            </Stack>
            <Typography sx={{ paddingTop: 2, lineHeight: 1.1, fontSize: 12, whiteSpace: 'pre-wrap', paddingY: 4 }}>
                {player.description}
            </Typography>
            <Stack spacing={2}>
                {player.units.sort(UNIT_SORT).map(u => <Stack key={u.id} sx={{ background: GREY[100], padding: 1, paddingX: 3, borderRadius: 2 }}>
                    <Stack direction={"row"} alignItems="center" justifyContent={"space-between"}>
                        <Stack direction={"row"} alignItems="center">
                            <Typography sx={{ paddingRight: 4, fontSize: 20, fontWeight: 600 }}>{u.cp}</Typography>
                            <Stack>
                                <CUnitBoxName unit={u} />
                                {u.xp >= 0 && <Typography sx={{ fontSize: 10, color: MAIN_COLOR_ACTIVE }}>Punti esperienza: {u.xp}</Typography>}
                            </Stack>
                        </Stack>
                        <UIcon size={32} name={u.grade} />
                    </Stack>

                    <Typography sx={{ paddingTop: 2, lineHeight: 1.1, whiteSpace: 'pre-wrap', paddingY: 2 }}>
                        {u.description}
                    </Typography>
                </Stack>)}
            </Stack>
        </DialogContent>
        <DialogActions>
            <UDialogClose>Chiudi</UDialogClose>
        </DialogActions>
    </UDialog>
}
export function CPlayerButton(props) {
    const { player, ...rest } = props;
    var wins = []
    var winExtra = <></>
    for (let i = 0; i < player.wins; i++) {
        wins.push(<UIcon key={'w' + i} name="winner" />)
    }
    if (player.wins > 4) {
        wins = [<UIcon name="winner" />]
        winExtra = <Typography>x{player.wins}</Typography>
    }

    return <UListItemButton sx={{
        border: '9px solid ' + GREY[100],
        borderLeft: 'none',
        zIndex: 2,
        padding: 0,
        paddingX: 2,
        background: 'linear-gradient(90deg, ' + MAIN_COLOR + ' 0%, ' + GREY[100] + ' 100% )',
    }}>
        <ListItemIcon>
            <WCodexIcon name={player.codex.name} />
        </ListItemIcon>
        <ListItemText
            primary={player.name}
            secondary={player.codex.name}
            secondaryTypographyProps={{ sx: { color: GREY[900] } }}
        />
        <Stack spacing={2} direction="row" justifyContent="center" sx={{ paddingRight: 2 }}>
            {wins}{winExtra}
        </Stack>
    </UListItemButton>
}

export function CDocument(props) {
    const { name, pdf, ...rest } = props;

    return <a target="_blank" style={{
        textDecoration: 'none',
    }} href={"/static/documents/" + pdf}>
        <UListItemButton sx={{
            border: '9px solid ' + GREY[100],
            background: '#652922',
        }}>
            <ListItemText sx={{
                color: WHITE,
            }} primary={name} />
            <UIcon name="doc" />
        </UListItemButton>
    </a>
}

export function CMatchJoin(props) {
    const { match, units, joinCall, onJoin, changeSelectedPointsCall, warnRequisition, warnRestore, ...rest } = props;
    const unitsById = group(units, 'id')
    const unitBySel = match.army.units.filter(u => Boolean(unitsById[u])).map(u => unitsById[u][0])
    const [selected, setSelected] = useState(unitBySel)
    const [remaining, setRemaining] = useState(match.army.remaining)
    const [call] = useRestCall(setRemaining)
    const isGrouped = match.army.limit <= 0
    const isEdit = match.army.units.length > 0
    const descLimit = isGrouped ? 'condiviso con i tuoi compagni di squadra' : match.army.limit

    function updateSelected(units) {
        setSelected(units)
        if (isGrouped) {
            var sum = 0;
            units.forEach(u => {
                sum += u.pts;
            })
            call(changeSelectedPointsCall, "" + sum)
        }
    }

    useEffect(() => {
        if (match.army.remaining !== remaining) {
            setRemaining(match.army.remaining)
        }
    }, [match.army.remaining])

    var pts = 0;
    selected.forEach(u => {
        pts += u.pts;
    })

    const warnRequisitionMessage = warnRequisition ? 'I tuoi Punti Requisizione sono superiori al limite consentito (5)! Utilizzali entro l\'inizio della partita altrimenti quelli in eccesso saranno perduti.' : undefined
    const warnRestoreMessage = warnRestore ? 'Hai ancora punti esperienza da recuperare! Utilizzali entro l\'inizio della partita altrimenti saranno perduti.' : undefined;

    return <CMatchDetails onClose={() => { updateSelected(unitBySel) }} match={match} {...rest}>
        <Typography>Esercito Crociato</Typography>
        <Typography sx={{ fontSize: 12, color: GREY[800], paddingBottom: 2 }}>
            Partecipa a questa missione componendo l'Esercito con limite <strong>{descLimit}</strong>
        </Typography>
        <UMarginBottom margin={6}>
            {units.length > 0 ? <CUnitSelection
                color1={SECONDARY_COLOR}
                color2={alpha(SECONDARY_COLOR, 0.3)}
                selected={selected}
                setSelected={updateSelected}
                units={units}
                remaining={isGrouped ? remaining : 0}
                limit={match.army.limit} /> : <Typography>Non ci sono unità nella tua Forza Crociata!</Typography>}

        </UMarginBottom>

        <UDialogCloseOnCompleteButton
            color="secondary"
            confirm={warnRequisitionMessage || warnRestoreMessage}
            call={joinCall}
            payload={{ units: selected.map(s => s.id) }}
            onComplete={onJoin}
            variant="contained"
            disabled={pts > match.limit || units.length == 0 || pts == 0} fullWidth>
            {!isEdit ? 'Partecipa' : 'Modifica'}
        </UDialogCloseOnCompleteButton>
    </CMatchDetails>
}
